import { HLong } from "@shared/src/datatypes/HLong";
import { PartnerAcquireRouteItemDto } from "./PartnerAcquireRouteItemDto";
import { RouteCardItemDto } from "../RouteCardItemDto";

export class AcquireRouteWizardCtrlDto {
  public step: number;
  public steps: number[];
  public selectedPartner: PartnerAcquireRouteItemDto;
  public selectedRoutesIds: Array<number>;
  public routesToAcquire: Array<RouteCardItemDto>;

  public invalid: boolean;
  public exceededMaximumNumberOfRoutesToAcquireJoints: boolean;

  public maximumNumberOfRoutesToAcquireJoints: number;


  public static build(oldCtrl: AcquireRouteWizardCtrlDto): AcquireRouteWizardCtrlDto {
    let newCtrl = new AcquireRouteWizardCtrlDto();
    if (oldCtrl != null) {
      newCtrl.step = oldCtrl.step;
      newCtrl.steps = oldCtrl.steps;
      newCtrl.selectedPartner = oldCtrl.selectedPartner;
      newCtrl.selectedRoutesIds = oldCtrl.selectedRoutesIds;
      newCtrl.routesToAcquire = oldCtrl.routesToAcquire;
      newCtrl.invalid = oldCtrl.invalid;
      newCtrl.exceededMaximumNumberOfRoutesToAcquireJoints = oldCtrl.exceededMaximumNumberOfRoutesToAcquireJoints;
      newCtrl.maximumNumberOfRoutesToAcquireJoints = oldCtrl.maximumNumberOfRoutesToAcquireJoints;
      newCtrl.calculateInternalData();
    }
    return newCtrl;
  }

  public calculateInternalData() {
    if (this.step == 1) {
      //Seleccionar partner
      this.invalid = this.selectedPartner == null || HLong.isNullOrNullLong(this.selectedPartner.partnerId);
    } else if (this.step == 2 || this.step == 3) {
      //Seleccionar rutes i/o resum
      this.invalid = this.selectedPartner == null || HLong.isNullOrNullLong(this.selectedPartner.partnerId);
      if (!this.invalid) {
        this.invalid = this.selectedRoutesIds == null || this.selectedRoutesIds.length == 0;
      }
    }

    this.exceededMaximumNumberOfRoutesToAcquireJoints = this.selectedRoutesIds && this.selectedRoutesIds.length > this.maximumNumberOfRoutesToAcquireJoints;
    if (this.exceededMaximumNumberOfRoutesToAcquireJoints)
      this.invalid = true;
  }

}